@if (viewModel$ | async; as vm) {
  <div class="header-content">
    <div class="header-doe-logo">
      <a routerLink="/home">
        <img src="/TDOE_Color.svg" alt="Tennessee State Seal"/>
      </a>
    </div>
    <div class="header-frtn-logo">
      <img src="/futurereadytn.png" alt="Future Ready Tennessee logo"/>
    </div>
    

    <nav class="horizontal-menu">
      <ul class="menu-level-1" [class.mobile-open]="mobileMenuOpen">
        <li class="mobile-menu-close-wrapper">
          <button class="mobile-menu-close" (click)="toggleMobileMenu()" type="button" aria-label="Close navigation menu">
            <span aria-hidden="true">Close</span>
          </button>
        </li>
        @for (item of vm.navItems; track item.text) {
          <li class="menu-item-level-1 rt-border"
              (mouseenter)="setHoveredItem(item, 1)"
              (mouseleave)="clearHoveredItem(1)">
            <a [href]="item.url"
               [attr.target]="item.target"
               [attr.rel]="item.target === '_blank' ? 'noopener noreferrer' : null"
               class="menu-link">
              {{ item.text }}
              @if (item.children && item.children.length > 0) {
                <!-- <mat-icon [class.rotated]="hoveredLevel1 === item">arrow_drop_down</mat-icon> -->
              }
            </a>

            @if (item.children && item.children.length > 0 && hoveredLevel1 === item) {
              <ul class="menu-level-2">
                @for (child of item.children; track child.text) {
                  <li class="menu-item-level-2"
                      (mouseenter)="setHoveredItem(child, 2)"
                      (mouseleave)="clearHoveredItem(2)">
                    <a [href]="child.url"
                       [attr.target]="child.target"
                       [attr.rel]="child.target === '_blank' ? 'noopener noreferrer' : null"
                       class="menu-link">
                      {{ child.text }}
                      @if (child.children && child.children.length > 0) {
                        <mat-icon [class.rotated]="hoveredLevel2 === child">arrow_drop_down</mat-icon>
                      }
                    </a>

                    @if (child.children && child.children.length > 0 && hoveredLevel2 === child) {
                      <ul class="menu-level-3">
                        @for (grandchild of child.children; track grandchild.text) {
                          <li class="menu-item-level-3"
                              (mouseenter)="setHoveredItem(grandchild, 3)"
                              (mouseleave)="clearHoveredItem(3)">
                            <a [href]="grandchild.url"
                               [attr.target]="grandchild.target"
                               [attr.rel]="grandchild.target === '_blank' ? 'noopener noreferrer' : null"
                               class="menu-link">
                              {{ grandchild.text }}
                              @if (grandchild.children && grandchild.children.length > 0) {
                                <mat-icon [class.rotated]="hoveredLevel3 === grandchild">arrow_drop_down</mat-icon>
                              }
                            </a>

                            @if (grandchild.children && grandchild.children.length > 0 && hoveredLevel3 === grandchild) {
                              <ul class="menu-level-4">
                                @for (greatgrandchild of grandchild.children; track greatgrandchild.text) {
                                  <li class="menu-item-level-4">
                                    <a [href]="greatgrandchild.url"
                                       [attr.target]="greatgrandchild.target"
                                       [attr.rel]="greatgrandchild.target === '_blank' ? 'noopener noreferrer' : null"
                                       class="menu-link">
                                      {{ greatgrandchild.text }}
                                    </a>
                                  </li>
                                }
                              </ul>
                            }
                          </li>
                        }
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    </nav>

    <button class="mobile-menu-toggle" (click)="toggleMobileMenu()">
      <img src="/hamburger-menu-icon.svg" alt="Menu"/>
    </button>

  </div>
  <tdoe-layout appName="FRTN" [headerNavItems]="vm.navItems">
    <router-outlet page></router-outlet>

    @if (vm.footerContent; as footerModel) {

      <ng-container footer>

        <footer>
          
          <div class="social">
            <div class="trending-content">CONNECT</div>

            @if (footerModel.footer_social_media_data.at(0)) {
              <a [href]="footerModel.footer_social_media_data[0].footer_social_media_link.url"
                 aria-label="Visit our Instagram page"
                 target="_blank"
                 rel="noopener noreferrer">
                <svg-icon src="/social/instagram-brands-solid.svg" [svgStyle]="{ 'height.px': 20, 'fill': ' #3d3e40' }"></svg-icon>
              </a>
            }

            @if (footerModel.footer_social_media_data.at(1)) {
              <a [href]="footerModel.footer_social_media_data[1].footer_social_media_link.url"
                 aria-label="Visit our X page"
                 target="_blank"
                 rel="noopener noreferrer">
                <svg-icon src="/social/x-twitter-brands-solid.svg" [svgStyle]="{ 'height.px': 20, 'fill': ' #3d3e40' }"></svg-icon>
              </a>
            }

            @if (footerModel.footer_social_media_data.at(2)) {
              <a [href]="footerModel.footer_social_media_data[2].footer_social_media_link.url"
                 aria-label="Visit our Facebook page"
                 target="_blank"
                 rel="noopener noreferrer">
                <svg-icon src="/social/facebook-f-brands-solid.svg" [svgStyle]="{ 'height.px': 20, 'fill': ' #3d3e40' }"></svg-icon>
              </a>
            }

            @if (footerModel.footer_social_media_data.at(3)) {
              <a [href]="footerModel.footer_social_media_data[3].footer_social_media_link.url"
                 aria-label="Visit our YouTube page"
                 target="_blank"
                 rel="noopener noreferrer">
                <svg-icon src="/social/flickr-brands-solid.svg" [svgStyle]="{ 'height.px': 20, 'fill': ' #3d3e40' }"></svg-icon>
              </a>
            }

            @if (footerModel.footer_social_media_data.at(4)) {
              <a [href]="footerModel.footer_social_media_data[4].footer_social_media_link.url"
                 aria-label="Visit our LinkedIn page"
                 target="_blank"
                 rel="noopener noreferrer">
                <svg-icon src="/social/linkedin-in-brands-solid.svg" [svgStyle]="{ 'height.px': 20, 'fill': ' #3d3e40' }"></svg-icon>
              </a>
            }

          </div>
        

          <div class="footer-cols">
            <div class="menu-cols">

              <div class="footer-menu-title">
                Our Other Sites
              </div>

              <ul class="footer-menu-list">
                @if (footerModel.footer_other_sites_sec.at(0)) {
                  <li>
                  <a [href]="[footerModel.footer_other_sites_sec[0].url]">
                  {{footerModel.footer_other_sites_sec[0].text}}
                  </a>
                  </li>
                }

                @if (footerModel.footer_other_sites_sec.at(1)) {
                  <li>
                  <a [href]="[footerModel.footer_other_sites_sec[1].url]">
                  {{footerModel.footer_other_sites_sec[1].text}}
                  </a>
                  </li>
                }

                @if (footerModel.footer_other_sites_sec.at(2)) {
                  <li>
                  <a [href]="[footerModel.footer_other_sites_sec[2].url]">
                  {{footerModel.footer_other_sites_sec[2].text}}
                  </a>
                  </li>
                }
              </ul>
            </div>

            
            <div class="">

              <div class="footer-menu-title">
                Quick Links
              </div>
                
              <ul class="footer-menu-list">
                @if (footerModel.footer_quick_links_sec.at(0)) {
                  <li>
                    <a [href]="[footerModel.footer_quick_links_sec[0].url]">
                    {{footerModel.footer_quick_links_sec[0].text}}
                    </a>
                  </li>
                }

                @if (footerModel.footer_quick_links_sec.at(1)) {
                    <li>
                      <a [href]="[footerModel.footer_quick_links_sec[1].url]">
                      {{footerModel.footer_quick_links_sec[1].text}}
                      </a>
                    </li>
                }

                @if (footerModel.footer_quick_links_sec.at(2)) {
                    <li>
                      <a [href]="[footerModel.footer_quick_links_sec[2].url]">
                      {{footerModel.footer_quick_links_sec[2].text}}
                      </a>
                    </li>
                }

                @if (footerModel.footer_quick_links_sec.at(3)) {
                    <li>
                      <a [href]="[footerModel.footer_quick_links_sec[3].url]">
                      {{footerModel.footer_quick_links_sec[3].text}}
                      </a>
                    </li>
                }

                @if (footerModel.footer_quick_links_sec.at(4)) {
                    <li>
                      <a [href]="[footerModel.footer_quick_links_sec[4].url]">
                      {{footerModel.footer_quick_links_sec[4].text}}
                      </a>
                    </li>
                }

                @if (footerModel.footer_quick_links_sec.at(5)) {
                    <li>
                      <a [href]="[footerModel.footer_quick_links_sec[5].url]">
                      {{footerModel.footer_quick_links_sec[5].text}}
                      </a>
                    </li>
                }

                </ul>
            </div>
            

            
            <div class="footer-menu-cols">

              <div class="footer-menu-title">
                About TDOE
              </div>
          
              <ul class="footer-menu-list">
                @if (footerModel.footer_about_tdoe_sec.at(0)) {
                  <li>
                    <a [href]="[footerModel.footer_about_tdoe_sec[0].url]">
                    {{footerModel.footer_about_tdoe_sec[0].text}}
                    </a>
                  </li>
                }
                
                @if (footerModel.footer_about_tdoe_sec.at(1)) {
                  <li>
                    <a [href]="[footerModel.footer_about_tdoe_sec[1].url]">
                    {{footerModel.footer_about_tdoe_sec[1].text}}
                    </a>
                  </li>
                }
                @if (footerModel.footer_about_tdoe_sec.at(2)) {
                  <li>
                    <a [href]="[footerModel.footer_about_tdoe_sec[2].url]">
                    {{footerModel.footer_about_tdoe_sec[2].text}}
                    </a>
                  </li>
                }

                @if (footerModel.footer_about_tdoe_sec.at(3)) {
                  <li>
                    <a [href]="[footerModel.footer_about_tdoe_sec[3].url]">
                    {{footerModel.footer_about_tdoe_sec[3].text}}
                    </a>
                  </li>
                }

              </ul>
            </div>
            
            <div class="contact">
              <strong>Department of Education<br/></strong>
              Lizzette Reynolds<br/>
              <br/>
              <address>
                  710 James Robertson Parkway<br/>
                  Nashville, TN 37243<br/>
              </address>
              <div class="footer-tn-seal">
                <img src="/tn-seal.png" alt="Tennessee State Seal"/>                           
              </div>      
            </div>       

          </div>

        </footer>

      </ng-container>

    }

  </tdoe-layout>
  
}
